import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
export const pinSlice = createSlice({
  name: 'pin',
  initialState: {
    gridFlag: '',
    isPin : true,
  },
  reducers: {
    pinReducer: (state, action) => {
      state.gridFlag = action.payload.gridFlag;
      state.isPin = action.payload.isPin;
      return state;
    }
  }
})
// case under reducers becomes an action 
export const { pinReducer } = pinSlice.actions
export default pinSlice.reducer 
